import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as diagnosticActions from '../actions/diagnostic.actions';
import * as autoLabelsActions from '../../autoLabels/actions/auto-labels.actions';
import { Diagnostic } from '../types/diagnostic';
import { diagnosticFactory } from '../utils/diagnostic.factory';

declare module 'react-redux' {
  interface DefaultRootState {
    userDiagnostic: UserDiagnosticState;
  }
}

export interface UserDiagnosticState {
  baseDiagnostic: Diagnostic;
  editableDiagnostic: Diagnostic;
}

const initialStateFactory = (): UserDiagnosticState => {
  const diagnostic = diagnosticFactory();
  return {
    baseDiagnostic: diagnostic,
    editableDiagnostic: diagnostic,
  };
};

export default reducer(
  initialStateFactory(),
  on(
    diagnosticActions.setDiagnostics,
    (state, { baseDiagnostic, editableDiagnostic }): UserDiagnosticState => ({
      ...state,
      baseDiagnostic,
      editableDiagnostic,
    }),
  ),
  on(
    diagnosticActions.save,
    (state): UserDiagnosticState => ({
      ...state,
      baseDiagnostic: state.editableDiagnostic,
    }),
  ),
  on(
    diagnosticActions.setAbnormalities,
    (state, { abnormalities }): UserDiagnosticState => {
      const editableDiagnostic = { ...state.editableDiagnostic, abnormalities };
      return {
        ...state,
        editableDiagnostic,
      };
    },
  ),
  on(
    diagnosticActions.setComment,
    (state, { comment }): UserDiagnosticState => {
      const editableDiagnostic = { ...state.editableDiagnostic, comment };
      return {
        ...state,
        editableDiagnostic,
      };
    },
  ),
  on(ecgActions.clean, () => initialStateFactory()),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { userDiagnostic } }): UserDiagnosticState => {
      if (!userDiagnostic) {
        return state;
      }
      return { ...state, ...userDiagnostic };
    },
  ),
  on(
    autoLabelsActions.addAssessmentLogs,
    (
      state,
      { labelsToAdd, labelsToRemove, abnormalities },
    ): UserDiagnosticState => ({
      ...state,
      editableDiagnostic: {
        ...state.editableDiagnostic,
        suggestionsLogs: {
          ...state.editableDiagnostic.suggestionsLogs,
          [Date.now()]: {
            labelsToAdd,
            labelsToRemove,
            abnormalities,
          },
        },
      },
    }),
  ),
);
